// extracted by mini-css-extract-plugin
module.exports = {"contactMethod":"Contact_contactMethod__2yE_n","icon":"Contact_icon__1hO-t","contactText":"Contact_contactText__CG0Yl","contact":"Contact_contact__gCJlu"};